/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Allow_DownloadInputs */

const cs_field_allow_download = /** @type {(inputs: Field_Allow_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Povolit stažení`)
};

const en_field_allow_download = /** @type {(inputs: Field_Allow_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow download`)
};

/**
* | output |
* | --- |
* | "Allow download" |
*
* @param {Field_Allow_DownloadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_allow_download = /** @type {((inputs?: Field_Allow_DownloadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Allow_DownloadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_allow_download(inputs)
	return cs_field_allow_download(inputs)
});